import { ContactChoice } from "../CaseStore/types";

export enum OfferStatus {
  NEW = "NEW",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  APPROVED = "APPROVED",
  ON_HOLD = "ON_HOLD",
}

export interface Offer {
  id?: string;
  caseId: string;
  city: string;
  contactChoice?: ContactChoice[];
  lawyer?: {
    id: string;
    firstName: string;
    lastName: string;
    barNo: string;
    email?: string;
  };
  user?: {
    id: string;
    firstName: string;
    lastName: string;
    phone?: string;
    email?: string;
  };
  approvalDate?: number;
  createDate?: number;
  updateDate?: number;
  status?: OfferStatus;
  summary: string;
  reason?: string;
}

export interface OfferParams {
  id?: string;
  status?: OfferStatus;
  summary: string;
  reason?: string;
  caseId?: string;
  userId?: string;
}

export enum OfferOrderBy {
  CASE_ID_ASC = "caseIdAsc",
  CASE_ID_DESC = "caseIdDesc",
  STATUS_ASC = "statusAsc",
  STATUS_DESC = "statusDesc",
  SUMMARY_ASC = "summaryAsc",
  SUMMARY_DESC = "summaryDesc",
  CREATE_DATE_ASC = "createDateAsc",
  CREATE_DATE_DESC = "createDateDesc",
}
